import { Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import TokenStore from '../stores/TokenStore';
import CurrentUserIdStore from '../stores/CurrentUserIdStore';
import CredAPI from '../util/CredAPI';

const SecretActions = {
  getSecrets() {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.getSecrets().then((secrets) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.SECRETS_RECEIVED,
        secrets,
      });
    });
  },

  addEmptySecret() {
    AppDispatcher.dispatch({
      actionType: Constants.Credentials.NEW_SECRET_ADDED,
    });
  },

  removeUnsavedSecret() {
    AppDispatcher.dispatch({
      actionType: Constants.Credentials.NEW_SECRET_REMOVED,
    });
  },

  saveSecret(secret) {
    const secretParams = new Map({
      resource_id: secret.resourceId,
      secret_name: secret.secretName || '',
      secret_value: secret.secretValue ? secret.secretValue : null,
      secret_key: secret.secretKey,
      owner_id: CurrentUserIdStore.getState(),
    });

    const secretParamsNoNulls = secretParams.filter(v => v !== null);

    if (secret.id > 0) {
      this.updateSecret(secret.id, secretParamsNoNulls);
    } else {
      this.createSecret(secretParams);
    }
  },

  // Secret CRUD Actions
  createSecret(newSecret) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.postSecret(newSecret).then((secret) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.SECRET_CREATED,
        secret,
      });
    });
  },

  getSecret(secretId) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.getSecret(secretId).then((secret) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.SECRET_RECEIVED,
        secret,
      });
    });
  },

  updateSecret(secretId, newSecretParams) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.updateSecret(secretId, newSecretParams).then((secret) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.SECRET_RECEIVED,
        secret,
      });
    });
  },

  deleteSecret(secretId) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.deleteSecret(secretId).then(() => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.SECRET_DELETED,
        secretId,
      });
    });
  },
};

export default SecretActions;
